export default {
      id: "graph-bsl-usage",
      viewBox: "0 0 158 120",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-bsl",
      toString: function () {
        return this.url;
      }
    }